import { Reveal } from "./Reveal";

export const FamilyStories = ({ stories }) => {
  if (!stories.length) return null;
  return (
    <section id="family-stories" data-testid="family-stories-section" className="section bg-[#FDFBF7] pt-0">
      <div className="mx-auto max-w-7xl px-6 sm:px-10 lg:px-16">
        <Reveal>
          <p className="eyebrow">In their words</p>
          <h2 data-testid="family-stories-heading" className="section-title mt-4">Why families are joining</h2>
        </Reveal>
        <ul className="mt-14 grid gap-6 md:grid-cols-2 lg:grid-cols-3">
          {stories.map((s, i) => (
            <Reveal as="li" key={s.id} delay={(i % 3) * 120}>
              <figure data-testid="family-story-card" className={`warm-card relative h-full p-8 ${i % 3 === 1 ? "bg-[#EAEFEA]" : ""}`}>
                <span aria-hidden="true" className="font-serif text-6xl leading-none text-[#D9A05B]/60">“</span>
                <blockquote data-testid="family-story-quote" className="-mt-4 whitespace-pre-line break-words font-serif text-xl leading-relaxed text-[#2C221E]">
                  {s.quote}
                </blockquote>
                <figcaption data-testid="family-story-name" className="mt-6 text-sm font-semibold text-[#C85A32]">— {s.name}</figcaption>
              </figure>
            </Reveal>
          ))}
        </ul>
      </div>
    </section>
  );
};
